import http from "../http-common";

class SignupDataService {
  getAll() {
    return http.get("/signup");
  }

  get(id) {
    return http.get(`/signup/${id}`);
  }

  getByEmail(email) {
    return http.get(`/signup/email/${email}`);
  }

  getLogin(email,password) {
    return http.get(`/signup/login/${email}/${password}`);
  }

  create(data) {
    return http.post("/signup", data);
  }

  createFeedback(data){
    return http.post("/signup/feedback", data);
  }

  update(id, data) {
    return http.put(`/signup/password/${id}`, data);
  }

  delete(id) {
    return http.delete(`/signup/${id}`);
  }

  deleteAll(id) {
    return http.delete(`/signup/${id}`);
  }

}

export default new SignupDataService();